<template>
    <layout-sidebar>
        <div id="app">
            <router-view></router-view>
        </div>
    </layout-sidebar>
</template>

<script>
    export default {
        name: "item-manage"
    }
</script>

<style lang="scss">


</style>